import { BookOpen, FileText, PlayCircle } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { useLang } from "@/lib/i18n";

const ITEMS = [
  ["/guide-employes-atlas.pdf", "nav.guidePdf", FileText, "employee-guide-pdf"],
  ["/video-employes-atlas.mp4", "nav.guideVideo", PlayCircle, "employee-guide-video"],
];

export const HelpMenu = () => {
  const { t } = useLang();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger data-testid="employee-guide-link" title={t("nav.guide")}
        className="press h-9 w-9 sm:w-auto sm:px-3 justify-center rounded-full border border-white/10 flex items-center gap-1.5 text-xs text-white/70 hover:text-white transition-colors outline-none">
        <BookOpen className="w-4 h-4" strokeWidth={1.5} /><span className="hidden sm:inline">{t("nav.guide")}</span>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[210px]">
        {ITEMS.map(([href, key, Icon, testid]) => (
          <DropdownMenuItem key={href} asChild>
            <a href={href} target="_blank" rel="noreferrer" data-testid={testid} className="flex items-center gap-2 cursor-pointer">
              <Icon className="w-4 h-4 text-[#C5A059]" />{t(key)}
            </a>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
